import * as React from "react";

type SectionDragHandleIconProps = {
  box?: number;
  /** `arrows` = 3×3 dots with up/down triangles; `lines` = three horizontal bars. */
  variant?: "arrows" | "lines";
};

/** Drag handle glyph — sized to fit a square hit target. */
export function SectionDragHandleIcon({
  box = 20,
  variant = "arrows",
}: SectionDragHandleIconProps) {
  if (variant === "lines") {
    const size = Math.round(box * 0.85);
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 14 14"
        fill="currentColor"
        aria-hidden
      >
        <rect x="1.5" y="2.75" width="11" height="1.75" rx="0.875" />
        <rect x="1.5" y="6.125" width="11" height="1.75" rx="0.875" />
        <rect x="1.5" y="9.5" width="11" height="1.75" rx="0.875" />
      </svg>
    );
  }

  // Tall glyph; scale so it fits inside the square button with a little padding.
  const height = Math.round(box * 0.9);
  const width = Math.round(height * (14 / 22));
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 22"
      fill="currentColor"
      aria-hidden
    >
      <path d="M7 1 L9.4 4.2 H4.6 Z" />
      <circle cx="3.5" cy="7.5" r="1.15" />
      <circle cx="7" cy="7.5" r="1.15" />
      <circle cx="10.5" cy="7.5" r="1.15" />
      <circle cx="3.5" cy="11" r="1.15" />
      <circle cx="7" cy="11" r="1.15" />
      <circle cx="10.5" cy="11" r="1.15" />
      <circle cx="3.5" cy="14.5" r="1.15" />
      <circle cx="7" cy="14.5" r="1.15" />
      <circle cx="10.5" cy="14.5" r="1.15" />
      <path d="M7 21 L9.4 17.8 H4.6 Z" />
    </svg>
  );
}
